<template>
  <div class="header-top wrap">
    <div v-show="!hideBtn" class="back-btn" @click="back">返回</div>
  </div>
</template>

<script>
export default {
  name: 'ViewBack',
  props: {
    hideBtn: Boolean
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    back () {
      window.history.back(-1)
    }
  }
}
</script>

<style lang="scss">
  .header-top {
    padding: 36px 0;
    /*height: 30px;*/
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 10;
    .back-btn{
      width: 80px;
      height: 30px;
      margin-left: 30px;
      font-size: 20px;
      color: #203152;
      letter-spacing: 0;
      line-height: 30px;
      text-indent: 20px;
      position: relative;
      cursor: pointer;
      &::before{
        content: ' ';
        position: absolute;
        left: 0;
        top: 5px;
        width: 12px;
        height: 18px;
        background: url("../assets/images/back.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
  }
</style>
